<template>
  <div>
    <PageHeader :order="order"></PageHeader>
    <div class="container">
      <main class="main">
        <div class="dataDisplay">
          <div class="dataDisplay__header">
            <div class="cassette cassette--onlyHeader">
              <div class="cassette__header" style="display: block;">
                <div class="cassette__img" style="float: left;">
                  <img :src="assetsImagePath.hospital_image" alt="hospital-image">
                </div>
                <div class="cassette__main" style="display: block;">
                  <div class="cassette__top">
                    <span class="label">{{ order.hospital_workplace_type }}</span>
                  </div>
                  <span class="displayHospitalTitle">事業所名</span>
                  <span class="displayHospitalName">{{ order.hospital_name }}</span>
                  <h2 class="cassette__heading">{{ order.catch_copy }}</h2>
                </div>
              </div>
            </div>
          </div>
          <div class="info__contents">
            <InformationTableHellowork :order="order" :isDisplayedMap="isDisplayedMap"></InformationTableHellowork>
            <div id="notice_inquiry">
              <p style="text-align: right;"> ※ この求人はハローワークから転載されたものです。ご不明点は最寄りのハローワークへお問い合わせください。</p>
            </div>
          </div>
          <div  class="detailDisplay__contents">
            <section class="contact">
              <div class="fix-contact"></div>
              <h4 class="contact__heading">ハローワーク求人担当者の問い合わせ先</h4>
              <div class="contact--hellowork_contents">
                <template v-if="isCurrentUser">
                  <table class="info__table info__table--hellowork_contact">
                    <tbody>
                      <tr>
                        <th>担当者<br class="is-sp">課係・役職</th>
                        <td>{{account.section_and_position}}</td>
                      </tr>
                      <tr>
                        <th>担当者名</th>
                        <td>{{account.name}}</td>
                      </tr>
                      <tr>
                        <th>担当者名<br class="is-sp">（フリガナ）</th>
                        <td>{{account.name_syllabary}}</td>
                      </tr>
                      <tr>
                        <th>電話番号</th>
                        <td>{{account.phone}}</td>
                      </tr>
                      <tr>
                        <th>メール<br class="is-sp">アドレス</th>
                        <td>{{account.email}}</td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template v-else>
                  <p style="text-align: center; margin-top: 20px; font-weight: bold;">問い合わせ先の確認にはログインが必要です</p>
                  <div class="info__btn">
                    <a class="btn btn--large btn--navy" href="/user/sign_in">
                  <span class="btn__text">
                    ログイン画面へ
                  </span>
                    </a>
                  </div>
                  <div class="info__btn">
                    <a class="btn btn--large btn--navy" href="/users/new">
                  <span class="btn__text">
                    会員IDをお持ちでない方
                  </span>
                    </a>
                  </div>
                </template>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import InformationTableHellowork from './components/order/InformationTableHellowork'
import PageHeader from './components/order/PageHeader'

export default {
  name: 'hellowork_order',
  props: [
    'initialOrderValue',
    'initialAccountValue',
    'initialImagePaths',
    'initialIsDisplayedMap',
    'initialUserStatus',
  ],
  data: function () {
    return {
      order: _.cloneDeep(this.initialOrderValue),
      account: _.cloneDeep(this.initialAccountValue),
      assetsImagePath: _.cloneDeep(this.initialImagePaths),
      isDisplayedMap: _.cloneDeep(this.initialIsDisplayedMap),
      isCurrentUser: _.cloneDeep(this.initialUserStatus)
    }
  },
  components: {
    InformationTableHellowork: InformationTableHellowork,
    PageHeader: PageHeader
  }
}
</script>
